module.exports = __webpack_public_path__ + "img/13.a1f59310.jpg";